module.exports = __webpack_public_path__ + "img/lvTopArr.8ae3cef9.png";